import React from "react"
import { Link } from "gatsby"
import { ActionBlock } from "trimble-terra"
import { formatCommonComponentFields } from "../LayoutComponents/formatLayoutFunctions"
import RichTextConnector from "../../../components/RichText/RichTextConnector"

const FormatAndRenderActionBlock = ({ data, locale, siteIdentifier, homepageSlug, currentSpaceId }) => {
  const formPreset = data?.theme === "Action Yellow" ? 't2-action-theme-one' : data?.theme === "Action Black" ? 't2-action-theme-two' : 't2-action-theme-three' ; 
  const displayType = data?.displayType === true ? "email" : "buttons";
  const headerIcon = displayType === "email" ? 't2u-mail' : null;

  const formattedComponentData = formatCommonComponentFields(data, locale, siteIdentifier, homepageSlug, currentSpaceId);
  const formattedForm = {
    ...data?.actionBlockForm?.[0],
    formType: 'Marketo',
    description: data?.actionBlockForm?.[0]?.description && <RichTextConnector data={{ content: data?.actionBlockForm?.[0]?.description }} />,
    followUpMessage: data?.actionBlockForm?.[0]?.followUpMessage && <RichTextConnector data={{ content: data?.actionBlockForm?.[0]?.followUpMessage }} />,
  }

  // email is a misnomer, but it means form.
  const displayMode = formattedComponentData.displayType ? 'email' : 'buttons';
  let formattedButtons = formattedComponentData?.buttons
  if(displayMode === 'email') {
    formattedButtons = [
      { label: formattedComponentData.actionBlockFormPlaceholder }
    ]
  }

  return (
    <div className={`t2-action-block__wrapper`} id={'action-block-1'}>
      <ActionBlock
        header={data?.actionBlockTitle}
        buttons={formattedButtons}
        headerIcon={headerIcon}
        presetTheme={formPreset}
        formPlaceholder={data?.actionBlockFormPlaceholder}
        Link={Link}
        formData={formattedForm}
        displayType={displayMode}
      />
    </div>
  )
}

export default FormatAndRenderActionBlock
